export const UTM_SOURCE = 'alvalabs';
export const UTM_MEDIUM = 'alvamarketplace';
